"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxInput = void 0;
const react_hook_form_1 = require("react-hook-form");
const checkbox_1 = require("../../checkbox");
const react_1 = __importDefault(require("react"));
const CheckboxInput = ({ control, name }) => {
    const { field } = (0, react_hook_form_1.useController)({ control, name });
    return react_1.default.createElement(checkbox_1.Checkbox, { disabled: field.disabled, checked: field.value, type: 'default', onChange: (checked) => {
            field.onChange(checked);
        } });
};
exports.CheckboxInput = CheckboxInput;
